import {
    CoverageDataDto,
    RosterType,
} from '../../coverage.coaching-insight.model';
import { RosterItem } from '../coaching-coverage-grid.model';
import { DateRange } from '../select-period-date-range.component';

export function padMissingData(
    roster: RosterItem[],
    periodDateRanges: DateRange[],
    data: CoverageDataDto,
): CoverageDataDto {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const result = data || ({} as CoverageDataDto);
    result.overall = result.overall || [];
    result.periods = result.periods || [];

    roster.forEach((e) => {
        const overallDat = result.overall.find((ee) => ee.userId === e.userId);
        if (!overallDat) {
            result.overall.push({
                userId: e.userId,
            });
        }

        periodDateRanges.forEach((week) => {
            const periodDat = result.periods.find(
                (ee) =>
                    ee.userId === e.userId &&
                    ee.startDate.getTime() === week.startDate.getTime() &&
                    ee.endDate.getTime() === week.endDate.getTime(),
            );
            if (!periodDat) {
                result.periods.push({
                    userId: e.userId,
                    rosterType: RosterType.OTHER,
                    startDate: week.startDate,
                    endDate: week.endDate,
                });
            }
        });
    });

    return result;
}
